/* Custom-type and call-price tables are edited as ordered rows (a dict can't hold
   a half-typed or duplicate key) and serialised to the policy dict on every change:
   blank keys are dropped, the last duplicate wins, and floor is clamped to price. */
import type { CallPricings, CustomPricings } from '../../../../api/client';

let rid = 0;
export const nid = () => ++rid;

/* ── Row ↔ dict (blank keys dropped, last duplicate wins, floor ≤ price) ── */

export interface CustomRow { id: number; name: string; price: number | null; floor: number | null }
export const customRowsFrom = (d: CustomPricings): CustomRow[] =>
  Object.entries(d || {}).map(([name, v]) => ({ id: nid(), name, price: typeof v?.price === 'number' ? v.price : null, floor: typeof v?.floor === 'number' ? v.floor : null }));
export function customDict(rows: CustomRow[]): CustomPricings {
  const out: CustomPricings = {};
  for (const r of rows) {
    const name = r.name.trim();
    if (!name) continue;
    const price = r.price ?? 0;
    out[name] = { price, floor: Math.min(r.floor ?? price, price) };
  }
  return out;
}

export interface CallRow { id: number; modality: 'voice' | 'video'; duration: string; price: number | null; floor: number | null }
function splitKey(key: string): { modality: 'voice' | 'video'; duration: string } {
  const k = key.trim();
  const l = k.toLowerCase();
  if (l.startsWith('voice')) return { modality: 'voice', duration: k.slice(5).trim() };
  if (l.startsWith('video')) return { modality: 'video', duration: k.slice(5).trim() };
  return { modality: 'video', duration: k };
}
export const callRowsFrom = (d: CallPricings): CallRow[] =>
  Object.entries(d || {}).map(([key, v]) => ({ id: nid(), ...splitKey(key), price: typeof v?.price === 'number' ? v.price : null, floor: typeof v?.floor === 'number' ? v.floor : null }));
export function callDict(rows: CallRow[]): CallPricings {
  const out: CallPricings = {};
  for (const r of rows) {
    if (!r.duration.trim()) continue;
    const price = r.price ?? 0;
    out[`${r.modality} ${r.duration.trim()}`.trim()] = { price, floor: Math.min(r.floor ?? price, price) };
  }
  return out;
}

